// Minimal Modal for react-native-web 0.11 (which ships without one).
import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { View } from "react-native-web";

export default class Modal extends React.Component {
  static propTypes = {
    animationType: PropTypes.oneOf(["none", "slide", "fade"]),
    transparent: PropTypes.bool,
    visible: PropTypes.bool,
    hardwareAccelerated: PropTypes.bool,
    onRequestClose: PropTypes.func,
    onShow: PropTypes.func,
    onDismiss: PropTypes.func,
    supportedOrientations: PropTypes.array,
    onOrientationChange: PropTypes.func,
  };

  static defaultProps = { visible: true, transparent: false };

  constructor(props) {
    super(props);
    this.host = document.createElement("div");
    this.host.className = "rn-modal-host";
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidMount() {
    document.body.appendChild(this.host);
    document.addEventListener("keydown", this.onKeyDown);
    if (this.props.visible && this.props.onShow) {
      this.props.onShow();
    }
  }

  componentDidUpdate(prev) {
    if (!prev.visible && this.props.visible && this.props.onShow) {
      this.props.onShow();
    }
    if (prev.visible && !this.props.visible && this.props.onDismiss) {
      this.props.onDismiss();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);
    if (this.host.parentNode) {
      this.host.parentNode.removeChild(this.host);
    }
  }

  onKeyDown(e) {
    if (e.key === "Escape" && this.props.visible && this.props.onRequestClose) {
      // only the top most modal reacts
      const hosts = document.querySelectorAll(".rn-modal-host");
      let top = null;
      hosts.forEach(h => {
        if (h.firstChild) {
          top = h;
        }
      });
      if (top === this.host) {
        this.props.onRequestClose();
      }
    }
  }

  render() {
    if (!this.props.visible) {
      return null;
    }
    const { transparent, children } = this.props;
    return ReactDOM.createPortal(
      <View
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1000,
          backgroundColor: transparent ? "transparent" : "#fff",
        }}
      >
        {children}
      </View>,
      this.host,
    );
  }
}
